import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { BalancesStep } from "@src/widgets/onboarding/classes/tours/MandatoryInitialSetupTour/steps/BalancesStep"
import { KybStep } from "@src/widgets/onboarding/classes/tours/MandatoryInitialSetupTour/steps/KybStep"
import { SettingsAutoConversionStep } from "@src/widgets/onboarding/classes/tours/MandatoryInitialSetupTour/steps/SettingsAutoConversionStep"
import { SettingsSecurityStep } from "@src/widgets/onboarding/classes/tours/MandatoryInitialSetupTour/steps/SettingsSecurityStep"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class MandatoryInitialSetupTour extends BaseTour {
  name = ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP

  steps = [
    new SettingsSecurityStep(),
    new SettingsAutoConversionStep(),
    new KybStep(),
    new BalancesStep(),
  ]
}
